<template>
  <div class="sub-sidebar">
    <slot name = "header" />
    <div class="sub-sidebar-header">
      <h3 class="text-uppercase">{{items.title}}</h3>
    </div>
    <div class="sub-sidebar-items">
      <div v-for="item in items.menu" class="mb-5">
        <h4 class="text-gray">{{item.title}}</h4>
        <div class="sub-sidebar-sub-items">
          <div v-for="subItem in item.items" class="mt-3">

            <router-link
              :to="subItem.link">{{subItem.title}}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "subSideBar",
    props: {
      items: {
        type: Object,
        default: ()=> {
          return {}
        }
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
